import React from 'react';
import { useSearchParams } from 'react-router-dom';
import classnames from 'classnames';
import logo from '@/static/images/favicon-logo.svg';
import sawlogo from '@static/images/saw-icon.svg';
import { isSAWDomain, isSAWPlan } from '@/utils';
import Switch from './Swtich';
import './index.less';

const LoginContent = (props: any) => {
	const contentRef = React.useRef<any>();
	const [contentStyle, setContentStyle] = React.useState({});
	const { style = {}, relative = false, title = '', subTitle = '', message = '', extra } = props;
	const [searchParams] = useSearchParams();

	const plan_type = searchParams.get('plan_type') || '';

	React.useEffect(() => {
		console.log('cal LoginContent');
		// 判断当前登录框高度
		if (props.kcLoadEnd && (contentRef.current.scrollHeight > document.documentElement.clientHeight)) {
			setContentStyle({ position: 'relative' });
		}
	}, [props.kcLoadEnd]);


	return (
		<div
			ref={contentRef}
			className={
				classnames({
					password: true,
					relative: relative,
				})
			}
			style={{ ...style, ...contentStyle }}
		>
			<div className="content">
				<div className="logo">
					<img src={(isSAWDomain() || isSAWPlan(plan_type)) ? sawlogo : logo} style={{ height: '64px' }} alt="" />
				</div>
				<h2 className="title">
					{title || `Splashtop Secure Workspace`}
				</h2>
				<p className="summary">{subTitle}</p>
				{props.children}
				{message && <p className="summary">{message}</p>}
				{<div className="topExtra"><Switch /></div>}
			</div>
			{extra && <div className="extra">{extra}</div>}
			{/* <Copyrights /> */}
		</div>
	);
};

export default LoginContent;
